"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var mobx_1 = require("mobx");
var library_1 = require("@zxing/library");
var react_toastify_1 = require("react-toastify");
var browser_1 = require("@sentry/browser");
var barcode_reader_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/common/barcode_reader"));
var content_1 = require("@hikakaku/shared/components/estimate_form/common/toast/content");
var convert_case_keys_1 = require("@hikakaku/shared/util/convert_case_keys");
var google_analytics_manager_1 = __importDefault(require("@hikakaku/shared/util/google_analytics_manager"));
var get_device_type_1 = require("@hikakaku/shared/util/get_device_type");
var ReaderLabel;
(function (ReaderLabel) {
    ReaderLabel["SEARCHING"] = "searching";
    ReaderLabel["READ_NEXT"] = "readNext";
})(ReaderLabel || (ReaderLabel = {}));
var TOAST_DISPLAY_TIME = 3000;
var TOAST_DISPLAY_INTERVAL = 1000; // 連続で表示が出過ぎないように間隔を開ける
var SEARCH_ITEMS_PATH = '/api/items';
var BarcodeReaderStore = /** @class */ (function () {
    function BarcodeReaderStore(props) {
        var _this = this;
        this.component = barcode_reader_1.default;
        this.active = false;
        this.foundCodes = [];
        this.notFoundCodes = [];
        this.allowsDisplayToast = true;
        this.handleClickStartButton = function (event) {
            event.preventDefault();
            _this.active = true;
        };
        this.handleClickCloseIcon = function (event) {
            event.preventDefault();
            _this.active = false;
        };
        this.toggleBarcodeReader = function (active) {
            if (active) {
                if (!navigator.mediaDevices) {
                    var message = ((0, get_device_type_1.getDeviceType)() === get_device_type_1.DeviceType.MOBILE_IOS || (0, get_device_type_1.getDeviceType)() === get_device_type_1.DeviceType.TABLET_IOS)
                        ? 'お手数ですが、バーコードリーダーは『Safari』でご利用ください。'
                        : undefined;
                    window.DialogStore.showDialogWithCloseButton('カメラにアクセスすることができませんでした', message);
                    _this.active = false;
                    return;
                }
                navigator.mediaDevices
                    // どうせ実機だとこのサイズで来ないので、サイズは適当ですが、cssで横幅いっぱいに調整してるので見た目は基本的にいい感じになります
                    .getUserMedia({ video: { facingMode: "environment", width: 500, height: 500 } })
                    .then(function (stream) {
                    if (!_this.videoRef.current) {
                        return;
                    }
                    google_analytics_manager_1.default.postGAEvent('査定ページ', 'click', 'バーコード起動');
                    _this.codeReader.decodeFromStream(stream, _this.videoRef.current, _this.handleReadVideoDevice);
                });
            }
            else {
                _this.codeReader.reset();
            }
        };
        this.handleReadVideoDevice = function (result) { return __awaiter(_this, void 0, Promise, function () {
            var janIsbnCode, response, data, item, insertedNumber, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!result) {
                            return [2 /*return*/];
                        }
                        janIsbnCode = result.getText();
                        if (this.searchingCode) {
                            return [2 /*return*/];
                        }
                        if (this.foundCodes.includes(janIsbnCode)) {
                            this.showToast('error', 'exclamation-triangle', '読み込みエラー', 'すでに読み込み済です');
                            return [2 /*return*/];
                        }
                        this.searchingCode = janIsbnCode;
                        this.readerLabel = ReaderLabel.SEARCHING;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, 7, 8]);
                        google_analytics_manager_1.default.postGAEvent('査定ページ', 'read', 'バーコード読み取り');
                        return [4 /*yield*/, axios_1.default.get(SEARCH_ITEMS_PATH, { params: (0, convert_case_keys_1.toSnakeKeys)({ janIsbnCode: janIsbnCode }) })];
                    case 2:
                        response = _a.sent();
                        data = response.data.data;
                        if (data === undefined || data === null) {
                            throw new Error();
                        }
                        if (!(data.items.length === 0)) return [3 /*break*/, 3];
                        if (!this.notFoundCodes.includes(janIsbnCode)) {
                            this.notFoundCodes.push(janIsbnCode);
                            google_analytics_manager_1.default.postGAEvent('error', '査定ページ', "\u30D0\u30FC\u30B3\u30FC\u30C9\u767B\u9332\u306A\u3057:".concat(janIsbnCode));
                        }
                        this.showToast('error', 'exclamation-triangle', '申し訳ございません', '商品が登録されていませんでした');
                        return [3 /*break*/, 5];
                    case 3:
                        this.foundCodes.push(janIsbnCode);
                        item = (0, convert_case_keys_1.toCamelcaseKeys)(data.items[0]);
                        return [4 /*yield*/, this.itemInputCardListStore.insertItem(item)];
                    case 4:
                        insertedNumber = _a.sent();
                        this.showToast('success', 'check-circle', "\u67FB\u5B9A\u5546\u54C1".concat(insertedNumber, "\u306B\u8AAD\u307F\u8FBC\u307E\u308C\u307E\u3057\u305F"), item.name, true);
                        if (this.itemInputCardListStore.lastItemCard.cardRef.current) {
                            this.itemInputCardListStore.lastItemCard.cardRef.current.scrollIntoView({
                                behavior: 'smooth',
                                block: 'center'
                            });
                        }
                        google_analytics_manager_1.default.postGAEvent('査定ページ', 'input', "\u30D0\u30FC\u30B3\u30FC\u30C9\u8AAD\u307F\u53D6\u308A\u6210\u529F:".concat(janIsbnCode));
                        _a.label = 5;
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        error_1 = _a.sent();
                        this.showToast('error', 'exclamation-triangle', '読み取りに失敗しました', 'もう一度お試しください');
                        (0, browser_1.captureException)(error_1);
                        return [3 /*break*/, 8];
                    case 7:
                        this.searchingCode = undefined;
                        this.readerLabel = ReaderLabel.READ_NEXT;
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        }); };
        this.showToast = function (type, icon, topText, mainText, forceDisplay) {
            if (forceDisplay === void 0) { forceDisplay = false; }
            if (!forceDisplay && !_this.allowsDisplayToast) {
                return;
            }
            if (_this.timeoutId) {
                clearTimeout(_this.timeoutId);
            }
            _this.allowsDisplayToast = false;
            (0, react_toastify_1.toast)((0, content_1.toastContent)(icon, topText, mainText), {
                type: type,
                position: 'top-center',
                hideProgressBar: true,
                autoClose: TOAST_DISPLAY_TIME
            });
            _this.timeoutId = window.setTimeout(function () { _this.allowsDisplayToast = true; }, TOAST_DISPLAY_TIME + TOAST_DISPLAY_INTERVAL);
        };
        this.videoRef = react_1.default.createRef();
        this.codeReader = new library_1.BrowserMultiFormatReader();
        this.itemInputCardListStore = props.itemInputCardListStore;
        (0, mobx_1.reaction)(function () { return _this.active; }, this.toggleBarcodeReader);
    }
    Object.defineProperty(BarcodeReaderStore.prototype, "readerLabelText", {
        get: function () {
            switch (this.readerLabel) {
                case ReaderLabel.SEARCHING:
                    return "".concat(this.searchingCode, "\u306E\u691C\u7D22\u4E2D...");
                case ReaderLabel.READ_NEXT:
                    return '次のバーコードを読み込んでください';
                default:
                    return undefined;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BarcodeReaderStore.prototype, "readerLabelClassNames", {
        get: function () {
            return this.readerLabel && (0, classnames_1.default)('estimateForm-BarcodeReader_ReaderLabel', "estimateForm-BarcodeReader_ReaderLabel-".concat(this.readerLabel));
        },
        enumerable: false,
        configurable: true
    });
    var _a;
    __decorate([
        mobx_1.observable,
        __metadata("design:type", typeof (_a = typeof react_1.RefObject !== "undefined" && react_1.RefObject) === "function" ? _a : Object)
    ], BarcodeReaderStore.prototype, "videoRef", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], BarcodeReaderStore.prototype, "active", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], BarcodeReaderStore.prototype, "readerLabel", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], BarcodeReaderStore.prototype, "searchingCode", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], BarcodeReaderStore.prototype, "foundCodes", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], BarcodeReaderStore.prototype, "notFoundCodes", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], BarcodeReaderStore.prototype, "allowsDisplayToast", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Number)
    ], BarcodeReaderStore.prototype, "timeoutId", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], BarcodeReaderStore.prototype, "readerLabelText", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], BarcodeReaderStore.prototype, "readerLabelClassNames", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], BarcodeReaderStore.prototype, "handleClickStartButton", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], BarcodeReaderStore.prototype, "handleClickCloseIcon", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], BarcodeReaderStore.prototype, "toggleBarcodeReader", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], BarcodeReaderStore.prototype, "handleReadVideoDevice", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], BarcodeReaderStore.prototype, "showToast", void 0);
    return BarcodeReaderStore;
}());
exports.default = BarcodeReaderStore;
